<template>
  <LayoutLanding>
    <div class="events-page">
      <!-- Hero Section -->
      <section class="events-hero">
        <div class="overlay-location">
          <h1>Eventos en SPARK81</h1>
          <p>¿Buscas un lugar donde celebrar de forma única? En SPARK81 llevamos el entretenimiento al siguiente nivel con experiencias inmersivas que harán de tu evento algo inolvidable.</p>
        </div>

      </section>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="page-content">
              <!-- Bloques de Eventos -->
              <div class="event-block">
                <div class="event-content">
                  <h3>Pack fiesta de cumpleaños</h3>
                  <p>Celebra tu subida de nivel con una sesión de juego con los tuyos. El Pack de Cumpleaños incluye:</p>
                  <ul>
                      <li><i class="fa-solid fa-person-running"></i>4 salas (turnos de 20 min)</li>
                      <li><i class="fa-solid fa-cake-candles"></i>30 minutos de celebración</li>
                      <li><i class="fa-solid fa-burger"></i>Merienda para los participantes</li>
                  </ul>

                  <p>Los detalles del pack cambian según la ubicación puedes ver los detalles en el proceso de reserva. Prepárate para una experiencia llena de acción, risas y retos que os pondrán a prueba como equipo. ¿Listos para el desafío?</p>
                  <div class="main-button">
                    <a href="#" @click.prevent="() => {$router.push('/booking')}">MONTA TU FIESTA</a>
                  </div>
                </div>
              </div>

              <div class="event-block">
                <div class="event-content">
                  <h3>Actividad de Team Building</h3>
                  <p>¿Tu equipo necesita un extra de chispa? SPARK81 es el lugar perfecto para fortalecer vínculos, superar obstáculos juntos y disfrutar de una sesión épica de acción y estrategia. Aquí no solo ganarás puntos, ganarás confianza y conexión con tu equipo.</p>
                  <div class="main-button">
                    <a href="#" @click.prevent="() => {$router.push('/booking')}">MONTA TU TEAM BUILDING</a>
                  </div>
                </div>
              </div>

              <div class="event-block">
                <div class="event-content">
                  <h3>Alquiler del espacio</h3>
                  <p>¿Un videoclip futurista? ¿Una sesión de fotos de otro nivel? ¿Quizás algo completamente nuevo que nadie haya hecho? SPARK81 es tu lienzo en blanco para crear, innovar y sorprender.</p>
                  <div class="main-button">
                    <a href="#" @click.prevent="() => {$router.push('/booking')}">SORPRÉNDENOS</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LayoutLanding>
</template>

<script>
import { onMounted, ref } from "vue";
import LayoutLanding from "@/components/LayoutLanding.vue";
import { axiosToken } from "../libs/http";
import { notify } from "notiwind";
export default {
  name: "EventsView",
  components: {
    LayoutLanding,
  },

};
</script>
